/**
 * Created by Owner on 2017/06/05.
 */
import {Injectable} from '@angular/core';
import {AppConfigService} from '../services/appConfig.service';

@Injectable()
export class SixMarkService {

  constructor(private configService: AppConfigService) {

  }

  /**
   * init
   * @param data = {flag: "init", lotteryid=82}
   * @param nav
   * @returns {Promise<T>}
   */
  sixMarkInit(data, nav: any) {
    data["flag"] = "init";
    return this.configService.getSixMarkService(data, nav);
  }
  /**
   * bet
   * @param data
   * @param nav
   * @returns {Promise<T>}
   */
  lotteryBetSM(data, nav: any) {
    data["flag"] = 'bet';
    return this.configService.getSixMarkService(data, nav);
  }

  /**
   * getCurIssue
   * @param data
   * @param nav
   * @returns {Promise<T>}
   */
  getCurIssue(data, nav: any) {
    data["flag"] = 'getCurIssue';
    return this.configService.getSixMarkService(data, nav);
  }
  /**
   * 查看最近开奖记录
   * @param data
   * @param nav
   * @returns {Promise<T>}
   * {
   * reslist:[{
   *    winnumber:"92471"
   *    issue:"0455期"
   * }]
   * }
   */
  lotteryWinOpenNumber(data, nav: any) {
    data["flag"] = "getopencodehistory";
    return this.configService.getSixMarkService(data, nav);
  }
  /**
   * 读取投注记录
   * @param data
   * @param nav
   * @returns {Promise<T>}
   * {
   *  reslist:
   * }
   */
  lotteryRecordBeanSM(data, nav: any) {
    data["flag"] = "getbetcodehistory";
    return this.configService.getSixMarkService(data, nav);
  }
  /**
   * lotteryRecordBeanInfo()
   */
  lotteryRecordBeanInfo(data, nav: any) {
    data["flag"] = "getbetdetail";
    return this.configService.getSixMarkService(data, nav);
  }
}



// WEBPACK FOOTER //
// ./src/services/sixmark.services.ts